import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PlatformToggles, toLocalInput } from "@/components/admin/SocialPublishActions";

export default function ScheduleEditDialog({ post, onClose, onSaved }) {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (post) setForm({ title: post.title || "", text: post.text || "", when: toLocalInput(new Date(post.send_at)), auto_social: post.auto_social || [] });
  }, [post]);

  const save = async () => {
    const dt = new Date(form.when);
    if (isNaN(dt.getTime()) || dt <= new Date()) { toast.error("Waktu posting harus di masa depan"); return; }
    setSaving(true);
    try {
      await api.put(`/scheduled-posts/${post.id}`, { title: form.title, text: form.text, send_at: dt.toISOString(), auto_social: form.auto_social });
      toast.success("Jadwal diperbarui");
      onSaved();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!post} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#FFFFFF] border-[#E2E8F0] text-slate-900 max-w-lg" data-testid="schedule-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Ubah Jadwal Posting</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">Hanya bisa diubah sebelum waktu posting tiba.</DialogDescription>
        </DialogHeader>
        {form && (
          <div className="space-y-3">
            <div>
              <Label className="text-xs text-slate-600">Judul</Label>
              <Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="schedule-edit-title" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" />
            </div>
            <div>
              <Label className="text-xs text-slate-600">Tanggal &amp; waktu</Label>
              <Input type="datetime-local" value={form.when} onChange={(e) => setForm({ ...form, when: e.target.value })} data-testid="schedule-edit-datetime" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" />
            </div>
            <div>
              <Label className="text-xs text-slate-600">Platform</Label>
              <div className="mt-1">
                <PlatformToggles value={form.auto_social} onChange={(v) => setForm({ ...form, auto_social: v })} hasImages={(post?.image_urls || []).length > 0 || !!post?.video_url} prefix="schedule-edit" />
              </div>
            </div>
            <div>
              <Label className="text-xs text-slate-600">Caption</Label>
              <Textarea rows={5} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} data-testid="schedule-edit-text" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1 text-sm" />
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose} data-testid="schedule-edit-cancel" className="rounded-xl">Batal</Button>
              <Button onClick={save} disabled={saving} data-testid="schedule-edit-save" className="bg-[#2563EB] hover:bg-[#1D4ED8] rounded-xl">
                {saving && <Loader2 size={14} className="animate-spin mr-1" />} Simpan
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
